// Native details keeps service links usable without JavaScript.
document.querySelectorAll('[data-service-disclosure]').forEach(disclosure => {
  disclosure.addEventListener('keydown', event => {
    if (event.key === 'Escape' && disclosure.open) {
      event.stopPropagation();
      disclosure.open = false;
      disclosure.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', event => {
    if (!disclosure.contains(event.target)) disclosure.open = false;
  });
  disclosure.addEventListener('focusout', event => {
    if (event.relatedTarget && !disclosure.contains(event.relatedTarget)) disclosure.open = false;
  });
});
